/* rh-in-your-size: product-page rows "More like this in size X" and
   "More from <brand> in size X". See sections/rh-in-your-size.liquid.

   Data source: the storefront's own search with filters, fetched as the
   rendered main-search section so we get real product cards (with size
   pills). Shopify's search supports field prefixes in q (tag:, vendor:) and
   the same filter.* params the search page uses. /collections/all cannot be
   used: storefront filtering is off for collections over 5,000 products.

   Size: localStorage rh_sizes = {letter, numeric, waist, shoe, kids}, the
   same memory the "Which size?" bar writes. This product's size option
   values decide which system applies. Choosing a size on this page saves it.
*/
(function () {
  if (window.__rhInYourSize) return;
  window.__rhInYourSize = true;

  var LS_SIZES = 'rh_sizes';
  var SIZE_PARAM = 'filter.v.option.size';
  var AVAIL_PARAM = 'filter.v.availability';
  var CAT_PARAM = 'filter.p.t.category';
  // Rendered by section FILE name, not the JSON-template instance id
  // (template--<id>__main): the instance id changes every time the theme is
  // duplicated, the file name does not. Shopify's Section Rendering API
  // accepts either; by file name it renders with the section's defaults.
  var FALLBACK_SECTION = 'main-search';

  var SCALE_LABEL = { letter: 'size', numeric: 'size', waist: 'waist', shoe: 'size', kids: 'size' };
  var COLOR_TAGS = ['black', 'white', 'red', 'green', 'blue', 'navy', 'pink', 'purple', 'yellow', 'orange', 'brown', 'tan', 'beige', 'grey', 'gray', 'cream', 'ivory', 'gold', 'silver', 'burgundy', 'olive', 'teal', 'coral', 'khaki', 'camel', 'rust', 'mustard', 'lavender', 'mint', 'taupe', 'charcoal', 'denim', 'multi', 'multicolor', 'metallic', 'nude', 'blush', 'sage', 'wine', 'plum', 'fuchsia', 'turquoise', 'aqua', 'peach'];
  var GENDER_TAGS = ['women', 'men', 'kids', 'girls', 'boys', 'unisex'];
  // Tag families the catalogue puts on every product (one value each).
  // These are the "looks like" signals: pattern first, then colour, material,
  // and length for dresses/skirts.
  var PATTERN_TAGS = ['solid', 'patterned', 'graphic', 'floral', 'stripe', 'striped', 'plaid-check', 'plaid', 'check', 'paisley', 'polka-dot', 'geometric', 'tie-dye', 'animal', 'gingham', 'camouflage', 'argyle', 'textured', 'tropical', 'abstract', 'colorblock', 'embroidered', 'sequin', 'lace', 'houndstooth', 'chevron', 'leopard', 'snake', 'zebra'];
  var MATERIAL_TAGS = ['cotton', 'cotton-blend', 'linen', 'linen-blend', 'polyester', 'viscose', 'viscose-blend', 'rayon', 'silk', 'leather', 'faux-leather', 'denim', 'wool', 'wool-blend', 'cashmere', 'cashmere-blend', 'nylon', 'nylon-blend', 'modal', 'knit', 'fleece', 'satin', 'velvet', 'suede', 'tencel', 'lyocell', 'spandex', 'jersey', 'chiffon', 'tweed', 'corduroy', 'canvas', 'mesh', 'sherpa', 'faux-fur'];
  var LENGTH_TAGS = ['mini', 'midi', 'maxi'];

  function lsGet(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function norm(v) { return String(v || '').trim().toLowerCase(); }

  // Same size-system rules as rh-size-prompt.js, minus the footwear-share
  // heuristic: on a product page we know the product, so plain 4-16 are
  // shoes only when the product type / category says footwear.
  function scaleOf(label, shoeProduct) {
    var k = norm(label);
    if (/^(xxxs|xxs|xs|s|m|l|xl|xxl|xxxl|xxxxl|\dxl|\dxs|[1-6]x|xs\/s|s\/m|m\/l|l\/xl|xl\/xxl|x-?small|small|medium|large|x-?large|xx-?large|xxx-?large)$/.test(k)) return 'letter';
    if (/^(\d+-\d+m|\d+m|\d+t|\d+y|\d+-\d+y|nb|newborn|\d+-\d+)$/.test(k)) return 'kids';
    if (/^(\d{2})\s*[x\/]\s*\d{2}$/.test(k)) return 'waist';
    var m = k.match(/^(?:us|eu|uk)?\s*(\d{1,2}(?:\.5)?)$/);
    if (m) {
      var n = parseFloat(m[1]);
      if (/^(us|eu|uk)/.test(k) || /\.5$/.test(k)) return 'shoe';
      if (shoeProduct && ((n >= 4 && n <= 16) || (n >= 34 && n <= 50))) return 'shoe';
      if (n >= 23 && n <= 50) return 'waist';
      return 'numeric';
    }
    return null;
  }

  function productScale(values, shoeProduct) {
    var counts = {};
    values.forEach(function (v) { var s = scaleOf(v, shoeProduct); if (s) counts[s] = (counts[s] || 0) + 1; });
    var best = null;
    for (var s in counts) if (!best || counts[s] > counts[best]) best = s;
    return best;
  }

  function esc(s) { return encodeURIComponent(s); }

  function searchUrl(sectionId, q, params) {
    var parts = ['section_id=' + esc(sectionId), 'type=product', 'q=' + esc(q)];
    for (var i = 0; i < params.length; i++) parts.push(params[i][0] + '=' + esc(params[i][1]));
    return '/search?' + parts.join('&');
  }

  function pageUrl(q, params) {
    var parts = ['type=product', 'q=' + esc(q)];
    for (var i = 0; i < params.length; i++) parts.push(params[i][0] + '=' + esc(params[i][1]));
    return '/search?' + parts.join('&');
  }

  // Resolves to a list of {handle, li}; to null when the section id is wrong
  // (Shopify answers 404 for an unknown section_id).
  function fetchCards(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (r.status === 404) return null; return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (html === null) return null;
        if (!html) return [];
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('ul.product-grid > li');
        var out = [];
        for (var i = 0; i < items.length; i++) {
          var li = items[i];
          var link = li.querySelector('a[href*="/products/"]');
          if (!link || !li.querySelector('.product-card-wrapper, .card-wrapper')) continue;
          var m = link.getAttribute('href').match(/\/products\/([^?#\/]+)/);
          if (!m) continue;
          out.push({ handle: m[1], li: li });
        }
        return out;
      })
      .catch(function () { return []; });
  }

  function cleanCard(li) {
    var node = li.cloneNode(true);
    // animations.js only observes .scroll-trigger nodes present at load;
    // imported ones would stay invisible.
    node.classList.remove('scroll-trigger', 'animate--slide-in');
    node.removeAttribute('data-cascade');
    node.removeAttribute('style');
    var inner = node.querySelectorAll('.scroll-trigger');
    for (var i = 0; i < inner.length; i++) inner[i].classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in');
    return node;
  }

  var root, D, state;

  function fillRow(name, heading, allHref, lists) {
    var row = root.querySelector('[data-row="' + name + '"]');
    if (!row) return 0;
    var grid = row.querySelector('[data-grid]');
    grid.innerHTML = '';
    var seen = {}; seen[D.handle] = true;
    var count = 0, max = parseInt(D.max, 10) || 8;
    for (var l = 0; l < lists.length && count < max; l++) {
      var list = lists[l];
      for (var i = 0; i < list.length && count < max; i++) {
        if (seen[list[i].handle]) continue;
        seen[list[i].handle] = true;
        grid.appendChild(cleanCard(list[i].li));
        count++;
      }
    }
    if (count < 2) { row.hidden = true; grid.innerHTML = ''; return 0; }
    row.querySelector('[data-heading]').textContent = heading;
    var all = row.querySelector('[data-all]');
    if (all) { if (allHref) { all.href = allHref; all.hidden = false; } else { all.hidden = true; } }
    row.hidden = false;
    return count;
  }

  function sizeSuffix(size) {
    if (!size) return '';
    return ' in ' + (SCALE_LABEL[state.scale] || 'size') + ' ' + size;
  }

  // The garment the shopper is actually looking at, read off the title
  // ("Jungle Toile Poplin Camp Shirt" -> "Camp Shirt"). The catalogue's
  // type/category is sometimes wrong (that camp shirt is typed as a tee), and
  // even when right it is broad; the title is what the merchant called it.
  var GARMENT = /^(shirt|shirts|tee|tees|t-shirt|t-shirts|top|tops|blouse|dress|dresses|gown|skirt|pant|pants|jean|jeans|short|shorts|jacket|coat|parka|anorak|blazer|vest|sweater|cardigan|hoodie|sweatshirt|pullover|polo|henley|romper|jumpsuit|overall|overalls|legging|leggings|jogger|joggers|trouser|trousers|chino|chinos|flannel|tank|cami|camisole|bodysuit|swimsuit|bikini|trunk|trunks|kimono|tunic|robe|pajama|pajamas|bra|boot|boots|sneaker|sneakers|sandal|sandals|loafer|loafers|heel|heels|mule|mules|clog|clogs|flat|flats|pump|pumps|wedge|wedges|slipper|slippers|hat|cap|beanie|bag|tote|backpack|scarf|belt|sock|socks|wallet|necklace|earring|earrings|bracelet|ring|sunglasses|watch)$/i;
  var QUALIFIER = /^(sleeve|neck|leg|waist|rise|collar|fit|length)$/i;
  var STOP = /^(and|the|with|of|in|for|a|an|&|\+|x)$/i;

  function titlePhrase(title, vendor) {
    var t = String(title || '');
    if (vendor && t.toLowerCase().indexOf(vendor.toLowerCase()) === 0) t = t.slice(vendor.length);
    t = t.replace(/[\(\[].*?[\)\]]/g, ' ')
      .replace(/\s+[-–|:]\s+.*$/, '')
      .replace(/\s+in\s+[\w\s\/-]+$/i, '')
      .replace(/\b(men'?s?|women'?s?|boys'?|girls'?|kids'?|unisex|ladies|mens|womens)\b/ig, ' ');
    var words = t.split(/\s+/).filter(function (w) { return w && !STOP.test(w) && COLOR_TAGS.indexOf(norm(w)) === -1; });
    if (!words.length) return { phrase: '', noun: '' };
    var idx = -1;
    for (var i = words.length - 1; i >= 0; i--) { if (GARMENT.test(words[i])) { idx = i; break; } }
    if (idx === -1) return { phrase: words.slice(-2).join(' '), noun: '' };
    var from = idx;
    if (idx > 0) { from = idx - 1; if (QUALIFIER.test(words[idx - 1]) && idx > 1) from = idx - 2; }
    return { phrase: words.slice(from, idx + 1).join(' '), noun: words[idx] };
  }

  function plural(phrase) {
    var p = phrase.toLowerCase();
    if (/(ss|x|ch|sh)$/.test(p)) return p + 'es';
    if (/s$/.test(p)) return p;
    if (/[^aeiou]y$/.test(p)) return p.slice(0, -1) + 'ies';
    return p + 's';
  }

  function render() {
    var size = state.size;
    var sizeParams = size ? [[SIZE_PARAM, size], [AVAIL_PARAM, '1']] : [[AVAIL_PARAM, '1']];
    var token = ++state.token;

    // --- row 1: "looks like this" --------------------------------------
    // Several searches, each a piece of evidence; a product's score is the
    // sum of the weights of the lists it turns up in (ties keep Shopify's
    // relevance order from the loose list). The garment is read off the
    // title; pattern / colour / material / length come from the catalogue's
    // tag families.
    var baseQ = state.genderTag ? 'tag:' + state.genderTag : (state.typeLeaf || D.categoryName || '');
    var gq = state.genderTag ? ' tag:' + state.genderTag : '';
    var similar = [], weights = [];
    function evidence(q, params, w) { similar.push(fetchCards(searchUrl(state.section, q, params))); weights.push(w); }
    if (state.phrase) {
      var loose = state.phrase + gq;
      evidence('"' + state.phrase + '"' + gq, sizeParams, 8);           // same garment by name: always leads
      evidence(loose, sizeParams, 0);                                    // the pool, in relevance order
      // "solid" and "graphic" are the catalogue's catch-alls (graphic covers
      // logo tees as much as prints), so they count for less than floral,
      // stripe, plaid-check, paisley...
      if (state.patternTag) evidence(loose + ' tag:' + state.patternTag, sizeParams, /^(solid|graphic)$/.test(state.patternTag) ? 1 : (state.patternTag === 'patterned' ? 2 : 3));
      if (state.lengthTag) evidence(loose + ' tag:' + state.lengthTag, sizeParams, 2);
      if (state.colorTag) evidence(loose + ' tag:' + state.colorTag, sizeParams, 1);
      if (state.materialTag) evidence(loose + ' tag:' + state.materialTag, sizeParams, 1);
    }
    var nPhrase = similar.length;
    if (!nPhrase && D.categoryId && baseQ) {
      var catParams = [[CAT_PARAM, D.categoryId]].concat(sizeParams);
      if (state.patternTag && state.genderTag) evidence(baseQ + ' tag:' + state.patternTag, catParams, 2);
      if (state.colorTag && state.genderTag) evidence(baseQ + ' tag:' + state.colorTag, catParams, 1);
      evidence(baseQ, catParams, 0);
    }
    if (!nPhrase && state.typeLeaf) {
      evidence(state.typeLeaf + gq, sizeParams, 0);
    }
    var phraseAll = state.phrase ? pageUrl(state.phrase + gq, sizeParams) : '';
    var catAll = D.categoryId && baseQ
      ? pageUrl(baseQ, [[CAT_PARAM, D.categoryId]].concat(sizeParams))
      : (state.typeLeaf ? pageUrl(state.typeLeaf, sizeParams) : '');
    var catWhat = D.categoryName ? D.categoryName.toLowerCase() : 'like this';

    // Merge the evidence lists into one ranked list. A candidate's own title
    // is evidence too: a "Tee" is not a "Shirt" even when the search thinks
    // the words are close enough.
    function nounClass(n) {
      n = norm(n).replace(/s$/, '');
      if (/^(tee|t-shirt)$/.test(n)) return 'tee';
      if (/^(pant|trouser|chino|jogger|legging)$/.test(n)) return 'pant';
      if (/^(sneaker|boot|sandal|loafer|heel|mule|clog|flat|pump|wedge|slipper)$/.test(n)) return 'shoe';
      return n;
    }
    var myNoun = state.noun ? nounClass(state.noun) : '';
    function rank(lists) {
      var byHandle = {}, order = [];
      for (var l = 0; l < lists.length; l++) {
        for (var i = 0; i < lists[l].length; i++) {
          var it = lists[l][i];
          if (it.handle === D.handle) continue;
          var e = byHandle[it.handle];
          if (!e) {
            e = byHandle[it.handle] = { handle: it.handle, li: it.li, score: 0, pos: order.length };
            order.push(e);
            if (myNoun) {
              var h = it.li.querySelector('.card__heading');
              var theirs = h ? titlePhrase(h.textContent, '').noun : '';
              if (theirs) e.score += nounClass(theirs) === myNoun ? 2 : -3;
            }
          }
          e.score += weights[l] - i / 1000;
        }
      }
      order.sort(function (a, b) { return b.score - a.score || a.pos - b.pos; });
      return [order];
    }

    // --- row 2: same brand, same department (a men's product never gets
    // the brand's women's line, and vice versa) ---
    var brandQ = D.vendor ? 'vendor:' + quote(D.vendor) + gq : '';
    var brand = brandQ ? [fetchCards(searchUrl(state.section, brandQ, sizeParams))] : [];
    var brandAll = brandQ ? pageUrl(brandQ, sizeParams) : '';

    var bad = function (lists) { return lists.some(function (l) { return l === null; }); };
    var retry = function () {
      // Wrong section id (search template rebuilt?): read the real one off
      // the search page once, then render again.
      if (state.resolved) return;
      state.resolved = true;
      fetch('/search?type=product&q=a', { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var m = html.match(/id="product-grid"[^>]*data-id="([^"]+)"/) || html.match(/data-id="([^"]+)"[^>]*id="product-grid"/);
          if (m && m[1] !== state.section) { state.section = m[1]; render(); }
        })
        .catch(function () {});
    };

    Promise.all(similar).then(function (lists) {
      if (token !== state.token) return;
      if (bad(lists)) return retry();
      // Heading and "See all" follow whichever tier actually produced the
      // cards: the title phrase when it found enough on its own (so a
      // "Ravello Shirt" with one match doesn't get a "More ravello shirts"
      // heading over a row of category results), otherwise the category.
      var seen = {}; seen[D.handle] = true; var exact = 0;
      if (nPhrase) for (var i = 0; i < lists[0].length; i++) { if (!seen[lists[0][i].handle]) { seen[lists[0][i].handle] = true; exact++; } }
      var what = exact >= 2 ? plural(state.phrase) : (state.noun ? plural(state.noun) : catWhat);
      fillRow('similar', 'More ' + what + sizeSuffix(size), nPhrase ? phraseAll : catAll, rank(lists));
    });
    Promise.all(brand).then(function (lists) {
      if (token !== state.token) return;
      if (bad(lists)) return retry();
      fillRow('brand', 'More from ' + D.vendor + sizeSuffix(size), brandAll, lists);
    });
  }

  function quote(v) { return /\s/.test(v) ? '"' + v.replace(/"/g, '') + '"' : v; }

  // --- the size picker on this page --------------------------------------
  function sizeFieldset(input) {
    var fs = input.closest('fieldset');
    if (!fs) return null;
    var legend = fs.querySelector('legend');
    return legend && /size|waist/i.test(legend.textContent) ? fs : null;
  }

  function onPick(value, save) {
    if (!value) return;
    var scale = scaleOf(value, state.shoeProduct);
    if (!scale) return;
    if (save) {
      var saved = lsGet(LS_SIZES) || {};
      if (saved[scale] !== value) { saved[scale] = value; lsSet(LS_SIZES, saved); }
    }
    if (state.scale !== scale || state.size !== value) {
      state.scale = scale; state.size = value;
      render();
    }
  }

  function start() {
    root = document.getElementById('rh-iys');
    if (!root) return;
    D = root.dataset;
    var tags = (D.tags || '').split('|').map(norm).filter(Boolean);
    var typeParts = (D.type || '').split('>').map(function (s) { return s.trim(); }).filter(Boolean);
    var shoeProduct = /shoe|sneaker|boot|sandal|heel|loafer|footwear|slipper|mule|clog|flat|pump|wedge/i.test((D.type || '') + ' ' + (D.categoryName || ''));
    var sizeValues = (D.sizeValues || '').split('|').filter(Boolean);

    state = {
      token: 0,
      section: (D.searchSection && D.searchSection.indexOf('template--') !== 0) ? D.searchSection : FALLBACK_SECTION,
      shoeProduct: shoeProduct,
      scale: productScale(sizeValues, shoeProduct),
      size: null,
      genderTag: tags.filter(function (t) { return GENDER_TAGS.indexOf(t) > -1; })[0] || null,
      colorTag: tags.filter(function (t) { return COLOR_TAGS.indexOf(t) > -1; })[0] || null,
      patternTag: tags.filter(function (t) { return PATTERN_TAGS.indexOf(t) > -1; })[0] || null,
      materialTag: tags.filter(function (t) { return MATERIAL_TAGS.indexOf(t) > -1; })[0] || null,
      lengthTag: tags.filter(function (t) { return LENGTH_TAGS.indexOf(t) > -1; })[0] || null,
      typeLeaf: typeParts.length ? typeParts[typeParts.length - 1] : '',
      phrase: '', noun: ''
    };
    var tp = titlePhrase(D.title, D.vendor);
    state.phrase = tp.phrase; state.noun = tp.noun;

    // Remembered size for this product's size system, if it is one this
    // product is sold in (so "size 8" never filters a letter-sized dress).
    var saved = lsGet(LS_SIZES) || {};
    if (state.scale && saved[state.scale]) state.size = saved[state.scale];

    // A size pre-selected through the URL (?variant= from a size pill) wins.
    // (Dawn also pre-selects the first available variant on a plain load,
    // which says nothing about the shopper, so only look when ?variant= is
    // there.)
    if (/[?&]variant=/.test(location.search)) {
      var all = document.querySelectorAll('variant-selects input[type="radio"]:checked, variant-radios input[type="radio"]:checked');
      for (var i = 0; i < all.length; i++) {
        if (sizeFieldset(all[i])) { var sc = scaleOf(all[i].value, shoeProduct); if (sc) { state.scale = sc; state.size = all[i].value; } }
      }
    }

    // Picking a size on this page = this is their size for that system.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (t.matches('variant-selects input[type="radio"], variant-radios input[type="radio"]') && sizeFieldset(t)) {
        onPick(t.value, true);
      } else if (t.matches('variant-selects select')) {
        var wrap = t.closest('.product-form__input');
        var lab = wrap && wrap.querySelector('label');
        if (lab && /size|waist/i.test(lab.textContent)) onPick(t.value, true);
      }
    });

    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
